// src/components/molecules/SubmissionDetails/SubmissionDetailsSection.js

import React from "react";
import { Grid, Box, Avatar, Link, Typography } from "@mui/material";

const SubmissionDetailsSection = ({ submissionDetails, theme }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs="auto">
          <Avatar
            alt={submissionDetails?.profileData?.userName}
            src={submissionDetails?.profileData?.profileImage}
            sx={{ width: 56, height: 56 }}
          />
        </Grid>

        <Grid item xs>
          <Box sx={{ ml: 2 }}>
            <Link
              href={`/challenge/profile/${submissionDetails?.profileData?.uid}`}
              underline="none"
              sx={{
                fontFamily: "basic-sans",
                fontSize: "1.2em",
                fontWeight: 500,
                color: theme.colors.green,
                cursor: "pointer",
                display: "block",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {submissionDetails?.profileData?.userName}
            </Link>
            <Typography
              variant="subtitle1"
              sx={{
                fontFamily: "basic-sans",
                color: theme.colors.white,
                fontWeight: 700,
              }}
            >
              {submissionDetails?.title}
            </Typography>
            {submissionDetails?.description && (
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "basic-sans",
                  color: theme.colors.darkGray,
                  mt: 1,
                  fontSize: {
                    xs: "0.8rem",
                    sm: "0.9rem",
                    md: "1rem",
                  },
                }}
              >
                {submissionDetails?.description}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubmissionDetailsSection;
